@if (isOk()) {
  <span class="ok">OK</span>
} @else {
  <span>必須</span>
}
